import React, { useEffect } from 'react';
import telegram from '../utils/telegram';
import './Header.css';

function Header({ title, subtitle, showPoints = false, points = 0, onBack = null }) {
  useEffect(() => {
    // Setup BackButton if onBack is provided
    if (onBack) {
      const handleBack = () => {
        telegram.hapticLight();
        onBack();
      };

      telegram.showBackButton(handleBack);

      // Cleanup
      return () => {
        telegram.hideBackButton();
      };
    }
  }, [onBack]);

  const handleBackClick = () => {
    if (onBack) {
      telegram.hapticLight();
      onBack();
    }
  };

  const handleTelegramClick = () => {
    telegram.hapticLight();
    telegram.openTelegramLink('https://t.me/+wBXI4N49pwdhNDY1');
  };

  return (
    <div className="app-header">
      <div className="header-top">
        {showPoints && (
          <div className="points-display">
            <span className="points-icon">⭐</span>
            <span className="points-value">{points}</span>
            <span className="points-label">VERA</span>
          </div>
        )}
        <button className="telegram-chat-btn" onClick={handleTelegramClick} title="Присоединиться к чату">
          <svg className="telegram-icon" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.562 8.161c-.18.717-1.558 7.315-2.2 9.712-.271.996-.806 1.33-1.321 1.362-.563.035-1.175-.232-1.823-.58-1.011-.543-1.582-.88-2.563-1.41-1.133-.612-.399-1.013.247-1.601.169-.154 3.107-2.85 3.165-3.094.007-.031.014-.145-.054-.206s-.164-.04-.234-.024c-.1.024-1.688 1.073-4.764 3.149-.451.311-.86.462-1.226.454-.404-.009-1.18-.228-1.758-.416-.709-.23-1.272-.352-1.223-.743.025-.203.31-.41.855-.62 3.35-1.458 5.583-2.419 6.7-2.882 3.19-1.326 3.852-1.556 4.285-1.563.095-.002.307.022.445.134.116.094.148.221.163.31.015.088.034.29.019.447z"/>
          </svg>
        </button>
      </div>
      <h1 className="header-title">{title}</h1>
      {subtitle && <p className="header-subtitle">{subtitle}</p>}
    </div>
  );
}

export default Header;
